<div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="showHint">
  <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="onHintDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
  <p><b>{{ resources.Info }}:</b></p>
  <div [innerHTML]="resources.PriceTypeInfo | sanitizeHtml"></div>
</div>

<div class="card">
  <h3 class="card-header">{{resources.ProductionPriceList}}</h3>
  <div class="card-body">
    <div class="container-fluid">
      <div class="row">

        <div class="form-group col-md-3 col-sm-12">
          <label>{{resources.ProductionPriceList}}</label>
          <div class="input-group">
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-select [formControl]="priceListType" placeholder="Select Price List" (selectionChange)="setSelectedPriceList()" >
                <mat-option *ngFor="let item of productionPriceLists | async " [value]="item.id">
                  {{item.market?.name}} {{item.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-group col-md-2 col-sm-12">
          <label>&nbsp;</label>
          <button class="btn btn-primary form-control" type="button" (click)="onSearch()">
            {{resources.ViewData}}
          </button>
        </div>
        <div class="form-group col-md-2 col-sm-12">
          <label>&nbsp;</label>
          <button class="btn btn-primary form-control" type="button" (click)="addCondition()">
            {{resources.Add}}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
<br />


<div class="panel" style="margin-top: 5px;">
  <div class="panel-body">
    <div class="quantity-filter">
       <mat-checkbox (change)="onShowOnlyValidConditions($event.checked)" [checked]="showOnlyValidConditions | async" #myCheckbox>
           {{resources.ShowValidConditions}}
       </mat-checkbox>
    </div>
  <div class="panel-body">
    <cal-calsiumlist-listing  [config]="listConfig" [ListBodyData]="productionPriceList | async"
      (sortTriggered)="onSort($event)" (filterTriggered)="onFilter($event)" (handleImportedFile)="onFileImport($event)"
      (wrongImportedFileTypeSelection)="onWrongImportedFileTypeSelection()"
      (clearFilterAndSortingTriggered)="onClearFilterAndSorting()" [isLoading]="isLoading | async"
      [filterExpression]="filterExpression | async" [dataTotalCount]="totalCount | async" 
      (exportToExcelTriggered)="onExport()">
    </cal-calsiumlist-listing>
    <cal-pagination [paging]="paging | async" (pageChange)="onPaging($event)" [dataTotalCount]="totalCount | async">
    </cal-pagination>
  </div>
</div>